export const ANDROID_SCHEME = process.env.REACT_APP_ANDROID_SCHEME
